import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 0,
  class: "fas fa-spinner fa-spin mr-1"
}
const _hoisted_3 = {
  key: 1,
  class: "fas fa-trash-alt mr-1"
}

import { computed, ref } from "vue";
import { useAuthStore } from "@/stores/auth";
import { adminEfpSoftDeleteEtiquette } from "@/api/adminEfp";
import { ConfirmModal } from "@/components";
import { useNotification } from "@/composables/useNotification";


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminLabelDeleteButton',
  props: {
    orderId: {},
    labelId: {},
    trackingNumber: {}
  },
  emits: ["deleted"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const authStore = useAuthStore();
const { success, error } = useNotification();

const isAdmin = computed(() => authStore.isImpersonating);
const showConfirm = ref(false);
const isDeleting = ref(false);

const confirmMessage = computed(() => {
  const tracking = props.trackingNumber?.trim();
  if (tracking) {
    return `Supprimer l'étiquette du colis (suivi : ${tracking}) ?\nCette action est irréversible côté vendeur.`;
  }
  return "Supprimer cette étiquette ?\nCette action est irréversible côté vendeur.";
});

const confirmDelete = async () => {
  showConfirm.value = false;
  if (!props.orderId || !props.labelId) return;

  isDeleting.value = true;
  try {
    const result = await adminEfpSoftDeleteEtiquette(
      props.orderId,
      props.labelId,
    );
    if (!result.ok) {
      throw new Error(result.error || "Erreur lors de la suppression");
    }
    success("Étiquette supprimée");
    window.dispatchEvent(new CustomEvent("orderLabelsChanged"));
    emit("deleted");
  } catch (e) {
    error(
      e instanceof Error ? e.message : "Erreur lors de la suppression",
    );
  } finally {
    isDeleting.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (isAdmin.value)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createElementVNode("button", {
          type: "button",
          class: "px-3 py-1.5 text-xs rounded-md text-white bg-red-600 hover:bg-red-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors whitespace-nowrap",
          disabled: isDeleting.value,
          title: "Supprimer l'étiquette (admin)",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showConfirm.value = true))
        }, [
          (isDeleting.value)
            ? (_openBlock(), _createElementBlock("i", _hoisted_2))
            : (_openBlock(), _createElementBlock("i", _hoisted_3))
        ], 8, _hoisted_1),
        _createVNode(_unref(ConfirmModal), {
          show: showConfirm.value,
          title: "Supprimer l'étiquette",
          message: confirmMessage.value,
          "confirm-text": "Supprimer",
          "show-attention-icon": true,
          onConfirm: confirmDelete,
          onCancel: _cache[1] || (_cache[1] = ($event: any) => (showConfirm.value = false))
        }, null, 8, ["show", "message"])
      ], 64))
    : _createCommentVNode("", true)
}
}

})